import { createApp, h, Fragment } from 'vue'
import App from "./App.vue";

// create root element for module
const div = document.createElement("div");
div.id = "tenjity-module";
document.body.appendChild(div);

// create the zoom wrapper and add all element inside
const zoomWrapper = document.createElement("div");
zoomWrapper.id = "zoomWrapper";
const childrens = Array.from(document.body.children);
childrens.forEach((element) => {
    if (element.tagName !== "NOSCRIPT" && element.tagName !== "SCRIPT" && element.id !== "tenjity-module") {
        zoomWrapper.append(element);
    }
});

document.body.append(zoomWrapper);

const tenjity_cta = document.querySelectorAll("[data-tenjity]")

if (process.env.NODE_ENV === 'development') {
    const VueAxe = require('vue-axe')
    createApp({
        render: () => h(Fragment, [h(App), h(VueAxe.VueAxePopup)])
    }).use(VueAxe.default).mount("#tenjity-module")
}
else {
    createApp(App).mount("#tenjity-module");
}

if (tenjity_cta.length > 0) {
    const moduleHeader = document.querySelector(".tenjityModule-header")
    moduleHeader.style.display = "none"
    moduleHeader.setAttribute("data-tenjity-customcta", true)
    for (let i = 0; i < tenjity_cta.length; i++) {
        tenjity_cta[i].addEventListener("click", () => {
            moduleHeader.setAttribute("data-tenjity-customcta", true)
            window.toggleModule()
            moduleHeader.style.display = "flex"
        })
    }
}